import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQkedvzBkDVg-7Mg5NUpAMz3-gBPx24Mc",
  authDomain: "mind121.firebaseapp.com",
  projectId: "mind121",
  storageBucket: "mind121.firebasestorage.app",
  messagingSenderId: "373559524403",
  appId: "1:373559524403:web:53dc99fddb582259d23746",
  measurementId: "G-WJGYWZM2EC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore
export const db = getFirestore(app);

// Initialize Analytics (optional)
// Uncomment the following line to enable analytics
// export const analytics = getAnalytics(app);